import React from 'react'

const useLocalStoreClear = () => {
  const clearLocalStorage = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("expireDate");
      localStorage.removeItem("userInfo");
      localStorage.removeItem("role");
      localStorage.removeItem("permissions");
      // Must be cleared with the rest: left behind, the next ORDINARY creator
      // to sign in on this browser would be handed the admin section set.
      localStorage.removeItem("isGranted");
  };

    return { clearLocalStorage };
}

export default useLocalStoreClear